import httpClient from '@/libs/http-client'

export function getCurrentNext () {
  const url = `/user_plan/get_current_next`

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}
